import { useCallback } from 'react';

import { usePostDisbursementPayoutDraftsIdPublish } from 'api';

import { useCurrentOrganisation } from 'hooks/context';

import { useDraftProgress } from '../contexts/DraftProgressProvider';

export const usePublishDraft = () => {
  const { id: organisationId } = useCurrentOrganisation();
  const { draftId } = useDraftProgress();
  const { mutateAsync: submitDraft } =
    usePostDisbursementPayoutDraftsIdPublish();

  const publishDraft = useCallback(() => {
    return submitDraft({
      organisationId,
      id: draftId
    });
  }, [submitDraft, organisationId]);

  return publishDraft;
};
